enum AIReviewScreenStatus {
    // The initial state where the review for screen has been requested but not yet started
    PENDING = "pending",
    // The review for screen is currently being processed
    IN_PROGRESS = "in_progress",
    // The review for screen was canceled by the user or system
    CANCELLED = "canceled",
    // The review for screen has been completed successfully
    COMPLETED = "completed",
    // The review for screen has been failed, no successful review for screen
    FAILED = "failed",
}

export default AIReviewScreenStatus;
